module.exports = __webpack_public_path__ + "media/assets/svg/illustrations/undraw_task_31wc-578204a03b619a83dac09d6fdc24da9f.svg";